import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ciscoUmbrella = defineConnector({
  identifier: "ciscoUmbrella",
  name: "Cisco Umbrella",
  tagLine: "Cloud security platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.umbrella\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in Cisco Umbrella",
      items: [
        {
          kind: "markdown",
          content:
            "Log into your [Cisco Umbrella dashboard](https://dashboard.umbrella.com) and navigate to **Admin > API Keys**. Click **Create** to generate new API credentials.",
        },
      ],
    },
    {
      title: "Configure your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Provide a descriptive name for your API key and select the appropriate scopes for your integration. Include **Deployments > Networks** with **Read-Only** access (`deployments.networks:read`) for the connection test. After creation, you’ll receive an API Key and API Secret.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your API key",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your API secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.umbrella.com/auth/v2/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.umbrella.com/deployments/v2/networks?limit=1",
  },
});
